import { app } from 'hyperapp'; // eslint-disable-line no-unused-vars
import { view } from './components/ApcQtySelector';

Array.from(document.querySelectorAll('.quantity')).forEach(item => {
    const hiddenInput = item.querySelector('.apc-qty-hiden-input');
    const hiddenInputId = hiddenInput.id;
    const actions = {
        select: ({ selected }) => () => ({
            selected,
        }),
    };

    app(
        { hiddenInputId, wrapper: item, originalValue: hiddenInput.value },
        actions,
        view,
        item.querySelector('.apc-qty-selector'),
    );
});
